import ValidationShema from 'constants/ValidationShema';

export default ValidationShema.lazy( values => {
	let shape = {}
	if(values.enabled){
		shape = {
			dealings: ValidationShema.arrayOfShape({
				value: ValidationShema.amount()
			})
		}
	}

	return ValidationShema.object(shape)
})